import { ICallLog } from '../../interfaces';
import api from '../../services/api';

export const getOngoingCallLog = (): Promise<{ call_log: ICallLog | undefined }> =>
  api.get('/api/frontend/call_logs/ongoing');
